import styled from "styled-components";
import usePageTitle from "hooks/usePageTitle";
import Logo from "../components/global/Logo";
import Spacer from "../components/global/Spacer";
import { socialIcons } from "../views/socialMedia/ManageChannels";
import { CustomArrowSVG, LogoNew } from "assets/icons/FacebookConnect";
import { forwardRef, useCallback, useEffect, useRef, useState } from "react";
import { showAlert } from "utils/utils";
import { axiosInstance, getTooltip, setLoggedIn } from "api";
import { connect } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import RadioInput from "components/global/RadioInput";
import ImgWrapper from "../components/global/ImgWrapper";
import userIcon from "assets/icons/userIconWhite.svg";
import Info from "components/global/Info";
import Loader from "../components/global/Loader";
import Button from "../components/global/Button";
import { Redirect } from "react-router-dom";
import arrowRight from "assets/icons/chevronLeft.svg";

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;

  .inner {
    padding: 24px;
  }

  .header {
    border-bottom: 1px solid #eaeaea;
    padding: 24px;
  }

  .selectionContainer {
    gap: 24px;
  }

  .iconContainer {
    gap: 16px;

    .iconWrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      border: 2px solid #e2e2ea;
      padding: 8px;
      border-radius: 8px;
      width: 48px;
      height: 48px;
    }
  }

  .chooseTargetItem {
    cursor: pointer;
    margin-bottom: 1.2rem;

    &:last-child {
      margin-bottom: 0;
    }

    label {
      font-size: 18px;
      line-height: 24px;
      cursor: pointer;
    }
  }

  .disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .userImageContainer {
    position: relative;
    width: 40px;
    height: 40px;

    .social-icon {
      position: absolute;
      bottom: 0;
      right: -8px;
      background-color: #fff;
      padding: 4px;
      border-radius: 50%;
      width: 24px;
      height: 24px;
    }
  }

  .instagramContainer {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .instagramCard {
    padding: 24px;
    border: solid var(--grey_10);
    display: flex;
    justify-content: space-between;
    border-radius: 8px;
    cursor: pointer;

    .buttonWrapper {
      display: flex;
      align-items: center;
      gap: 8px;
      border: 1px solid #e2e2ea;
      padding: 8px;
      border-radius: 50%;

      img {
        transform: rotate(180deg);
      }
    }
  }

  @media screen and (max-width: 768px) {
    .heading {
      font-size: 24px;
      line-height: 32px;
      width: 28.6rem;
    }

    .subHeading {
      font-size: 18px;
      line-height: 24px;
      width: 100%;
    }
  }
`;

const FacebookContainer = forwardRef(
  ({ item, selectedAccountId, handleSelectAccount }, ref) => {
    const [profilePic, setProfilePic] = useState("");

    const getProfilePic = async () => {
      try {
        const res = await axiosInstance.get(
          `https://graph.facebook.com/v17.0/${item?.id}?fields=picture&transport=cors&access_token=${item?.access_token}`
        );
        setProfilePic(res.data?.picture?.data?.url);
      } catch (error) {
        console.log(error);
      }
    };

    useEffect(() => {
      getProfilePic();
      // eslint-disable-next-line
    }, []);

    return (
      <>
        <div
          className={`flexRow alignCenter chooseTargetItem ${
            item.exists && "disabled"
          }`}
          ref={ref}
        >
          <RadioInput
            id={`_${item.id}`}
            name="facebook_page"
            value={item.id}
            checked={selectedAccountId === item.id}
            onClick={() => handleSelectAccount(item.id, profilePic)}
            disabled={item.exists}
          />
          <Spacer x={1.2} />
          <div>
            <label htmlFor={`_${item.id}`} className="flexRow alignCenter">
              <div className="userImageContainer">
                <ImgWrapper size={4.0} imgHeight={"100%"}>
                  <img src={item.profile_picture || userIcon} alt="avi" />
                </ImgWrapper>
                <div className="social-icon flexRow alignCenter justifyCenter">
                  <img
                    src={socialIcons.circle["facebook"]}
                    alt="text"
                    width="16px"
                  />
                </div>
              </div>
              <Spacer x={1.2} />
              <span className="text l3 colorBodyText">{item.name}</span>
            </label>
            {item?.exists && (
              <div className="info">
                <Spacer y={0.4} />
                <Info
                  content={`Page connected to ${item.owner} workspace on PostPaddy`}
                  color="#865503"
                />
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
);

const SelectAccount = ({
  brand,
  onboarding_state,
  user,
  user_token,
  refresh_token,
}) => {
  usePageTitle("Select account");
  const router = useHistory();
  const { platform } = useParams();
  const socials = brand?.socials.socials;
  const { search } = useLocation();
  const authMobileProvider = localStorage.getItem("authMobileProvider");

  const connectedTo = new URLSearchParams(search).get("connected_to");
  const accessToken = new URLSearchParams(search).get("access_token");
  const redirectPath = new URLSearchParams(search).get("return_to");

  const [accounts, setAccounts] = useState([]);
  const [fetchingAccounts, setFetchingAccounts] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [page, setPage] = useState(null);
  const [nextPage, setNextPage] = useState("");
  const [hasMore, setHasMore] = useState(true);
  const [selectedAccountId, setSelectedAccountId] = useState("");
  const [selectedAccountProfilePic, setSelectedAccountProfilePic] =
    useState("");
  const getAccounts = useCallback(async () => {
    if (!brand?.id) return;
    setFetchingAccounts(true);
    try {
      let res = await axiosInstance.get(
        `${platform}/${brand?.id}/pages/get?count=15${
          nextPage ? `&next=${nextPage}` : ""
        }`
      );
      if (res.data.status === false) {
        showAlert({
          msg: res.data.message,
          type: "danger",
        });
      } else {
        const list = res.data?.data?.pages;
        if (platform === "instagram") {
          setHasMore(res.data?.data?.next !== null ? true : false);
          setPage(res.data?.data?.next);
        } else {
          setHasMore(res.data?.data?.pagination?.next !== null ? true : false);
          setPage(res.data?.data?.pagination?.next);
        }

        list &&
          setAccounts((prev) => {
            return [...new Set([...prev, ...list])];
          });
        list?.forEach((account) => {
          if (account.selected) {
            setSelectedAccountId(
              platform === "instagram" ? account.ig_id : account.id
            );
          }
        });
      }
      setFetchingAccounts(false);
    } catch (e) {
      showAlert({
        msg: "Error. Could not get accounts",
        type: "danger",
      });
      setFetchingAccounts(false);
      console.log(e);
    }
  }, [brand, nextPage, platform]);

  const handleSelectAccount = (accountId, profilePic) => {
    if (!accountId) return;
    setSelectedAccountId(accountId);
    setSelectedAccountProfilePic(profilePic);
  };

  const handleSubmitAccount = useCallback(
    async (e) => {
      e.preventDefault();

      let data = [];

      data = accounts?.filter((item) => {
        if (item.ig_id) {
          return item.ig_id === selectedAccountId;
        }
        return item.id === selectedAccountId;
      });

      if (platform === "facebook" && !!data.length) {
        data[0].profile_picture = selectedAccountProfilePic;
      }

      if (data?.length > 0) {
        setSubmitting(true);

        try {
          let res = await axiosInstance.post(
            `${platform}/${brand?.id}/page/store`,
            { accounts: data }
          );
          if (res.data.status === false) {
            showAlert({
              msg: res.data.message ?? "An error occurred.",
              type: "danger",
            });
          } else {
            router.push("/onboarding");
          }
          setSubmitting(false);
        } catch (e) {
          setSubmitting(false);
          showAlert({
            msg: e.response.data.message || "An error occurred. Try again",
            type: "danger",
          });
        }
      } else {
        showAlert({
          msg: "You must make at least one selection",
          type: "danger",
        });
      }

      data = [];
    },
    // eslint-disable-next-line
    [platform, accounts, selectedAccountId]
  );

  const createAccountWithIg = async () => {
    try {
      const url = `/auth/instagram/complete`;
      const res = await axiosInstance.post(url, {
        access_token: accessToken,
      });

      if (res.data.status === false) {
        showAlert({
          msg: res.data.message,
          type: "danger",
        });
        return;
      }
      await getTooltip();
      router.push("/onboarding");
    } catch (error) {
      showAlert({
        msg: error.response?.data?.message ?? "An error occurred",
        type: "danger",
      });
    }
  };

  const observer = useRef();
  const lastListElementRef = useCallback(
    (node) => {
      if (fetchingAccounts) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setNextPage(page);
        }
      });
      if (node) observer.current.observe(node);
    },
    // eslint-disable-next-line
    [fetchingAccounts, hasMore]
  );

  useEffect(() => {
    if (brand) {
      getAccounts();
    }
    // eslint-disable-next-line
  }, [brand, nextPage]);

  if (onboarding_state.onboarding_completed && authMobileProvider) {
    window.location.href = `postpaddy.app://(dashboard)/home?token=${user_token}&refresh_token=${refresh_token}&success=true`;
    setLoggedIn(false);
  } else if (onboarding_state.onboarding_completed) {
    return <Redirect to={redirectPath ?? "/dashboard/home"} />;
  } else if (
    socials?.find((item) => item.platform === platform) &&
    onboarding_state.onboarding_completed
  ) {
    return <Redirect to={redirectPath ?? "/dashboard/home"} />;
  } else if (
    socials?.find((item) => item.platform === platform) &&
    !onboarding_state.onboarding_completed
  ) {
    return (
      <Redirect
        to={`/onboarding?return_to=${encodeURIComponent(redirectPath)}`}
      />
    );
  }

  return (
    <Wrapper>
      <div className="flexRow alignCenter header">
        <Logo />
        <Spacer x={1} />
        <p>PostPaddy</p>
      </div>

      <div className="flexRow alignCenter justifyCenter inner">
        <div className="flexColumn alignCenter selectionContainer">
          <div className="flexRow alignCenter iconContainer">
            <div className="iconWrapper">
              <LogoNew />
            </div>
            <CustomArrowSVG />
            <div className="iconWrapper">
              <img src={socialIcons.circle[platform]} alt="" />
            </div>
          </div>

          <div className="textCenter">
            <h5 className="bold">
              {platform === "facebook"
                ? "Which channel would you like to add?"
                : "Choose an account"}
            </h5>
            <p className="l3 colorBodyText">
              {platform === "facebook"
                ? "Select a Facebook Business Page to link with your PostPaddy account."
                : "This Instagram account is linked to an existing account, what would you like to do?"}
            </p>
          </div>

          <div>
            {platform === "facebook" &&
              accounts.length >= 1 &&
              accounts.map((item, index) => {
                return (
                  <FacebookContainer
                    item={item}
                    key={index}
                    selectedAccountId={selectedAccountId}
                    handleSelectAccount={handleSelectAccount}
                    ref={
                      accounts?.length === index + 1 ? lastListElementRef : null
                    }
                  />
                );
              })}

            {platform === "instagram" && (
              <div className="instagramContainer">
                <div
                  className="instagramCard"
                  onClick={() =>
                    router.push(`/sign-up?return_to=${redirectPath}`)
                  }
                >
                  <div>
                    <p className="l3 semiBold">Login with another account</p>
                    <p className="l3 colorBodyText">
                      This account is already connected to{" "}
                      <span className="semiBold">{connectedTo}</span> brand
                    </p>
                  </div>
                  <div className="buttonWrapper">
                    <img src={arrowRight} alt="" />
                  </div>
                </div>
                <div className="instagramCard" onClick={createAccountWithIg}>
                  <div>
                    <div className="flexRow alignCenter justifySpaceBetween">
                      <div>
                        <p className="l3 semiBold">
                          Create a new PostPaddy account
                        </p>
                        <p className="l3 colorBodyText">
                          Create a new PostPaddy account using this Instagram
                          account.
                        </p>
                      </div>
                      <div className="buttonWrapper">
                        <img src={arrowRight} alt="" />
                      </div>
                    </div>
                    <Spacer y={1.2} />
                    <Info
                      content={`This will disconnect it from ${connectedTo} brand and create a new account for you.`}
                      color="#865503"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
          {fetchingAccounts && (
            <div className="flexRow justifyCenter">
              <Loader type="spinner" />
            </div>
          )}
        </div>
      </div>

      {platform !== "instagram" && (
        <div className="flexRow justifyCenter actionBtns">
          <Button
            type="button"
            text="Cancel"
            className="borderedGrey l3"
            width="200px"
            height="36px"
            onClick={() => router.push("/dashboard")}
          />
          <Spacer x={2.4} />
          <Button
            type="submit"
            text="Add"
            height="36px"
            width="200px"
            onClick={handleSubmitAccount}
            disabled={submitting || !selectedAccountId}
            loading={submitting}
          />
        </div>
      )}

      {platform === "instagram" && (
        <div className="flexRow alignCenter justifyCenter l3">
          <p>
            Do you need help?{" "}
            <span className="colorSecondary cursorPointer support-tour">
              Contact customer support
            </span>
          </p>
        </div>
      )}
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    brand: state.brand,
    onboarding_state: state.guided_tours,
    user_token: state.user_token,
    refresh_token: state.refresh_token,
  };
};

export default connect(mapStateToProps)(SelectAccount);
